export default function LendoOpeningHours() {
    const openingHours = {
        Mandag: '08:00 - 17:00',
        Tirsdag: '09:00 - 20:00',
        Onsdag: '08:00 - 20:00',
        Torsdag: '09:00 - 20:00',
        Fredag: '08:00 - 18:00',
        Lørdag: '10:00 - 15:00',
    };

    return (
        <div className="lendo-opening-hours">
            {Object.entries(openingHours).map(([day, hours]) => (
                <div className="day" key={day}>
                    <span>{day}</span>
                    <span>{hours}</span>
                </div>
            ))}
        </div>
    );
}

